export default class ViewTaskCtrl {
  constructor(
    Authentication,
    PersonaCollection,
    Restangular,
    NotificationCollection,
    TaskCollection,
    TaskService,
    notification,
    task,
    $uibModalInstance
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      Restangular,
      NotificationCollection,
      TaskCollection,
      TaskService,
      notification,
      task,
      $uibModalInstance,
    });
    this.init();
  }

  init() {
    this.users = this.PersonaCollection.users;
    this.notificationDateFormat = 'EEEE • MMMM dd • ';
    this.notificationDateFormat += this.Authentication.user.settings.usTimeFormat
      ? 'h:mm a'
      : 'H:mm';

    if (this.notification) {
      this.canDismissNotification =
        !this.notification.archived && this.notification.actions.find((a) => a.type === 'neutral');
    }
  }

  dismissNotification() {
    const neutral = this.notification.actions.find((a) => a.type === 'neutral');
    return this.Restangular.all(neutral.url)
      .post()
      .then(this.NotificationCollection.addOrEditNotification)
      .then((data) => {
        this.$uibModalInstance.close();
        return data;
      });
  }

  modalNotification() {
    if (this.notification) {
      if (this.notification.archived) {
        return 'This notification has been archived';
      }
      if (this.notification.type === 'task_completed') {
        return this.TaskService.getCompletedMessage(this.task, this.notificationDateFormat);
      } else if (this.notification.type === 'task_cancelled') {
        return 'This task has been cancelled';
      } else if (this.notification.type === 'task_changed') {
        return 'This task has been changed';
      }
    }

    return false;
  }

  modalClass() {
    if (this.notification?.archived) {
      return 'notification-gray';
    }

    if (this.notification) {
      return `notification-${this.notification.color}`;
    }
  }

  goBack() {
    this.historyMode = false;
  }

  async goToHistoryMode() {
    this.historyMode = true;
    this.history = await this.TaskCollection.getLogs(this.task.id);
  }
}
